(function webpackUniversalModuleDefinition(root, factory) {
  if(typeof exports === 'object' && typeof module === 'object')
    module.exports = factory();
  else if(typeof define === 'function' && define.amd)
    define([], factory);
  else if(typeof exports === 'object')
    exports["FloatingISI"] = factory();
  else
    root["FloatingISI"] = factory();
})(window, function() {
  return /******/ (function(modules) { // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/
      if(installedModules[moduleId]) {
        /******/
        return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/
        i: moduleId,
        /******/
        l: false,
        /******/
        exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function(exports, name, getter) {
      /******/
      if(!__webpack_require__.o(exports, name)) {
        /******/
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function(exports) {
      /******/
      if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function(value, mode) {
      /******/
      if(mode & 1) value = __webpack_require__(value);
      /******/
      if(mode & 8) return value;
      /******/
      if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
      /******/
      var ns = Object.create(null);
      /******/
      __webpack_require__.r(ns);
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      });
      /******/
      if(mode & 2 && typeof value != 'string')
        for(var key in value) __webpack_require__.d(ns, key, function(key) {
          return value[key];
        }.bind(null, key));
      /******/
      return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function(module) {
      /******/
      var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function(object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = "./src/index.js");
    /******/
  })
  /************************************************************************/
  /******/
  ({

    /***/
    "./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js?!./src/style.scss":
      /*!***************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js??ref--5-2!./src/style.scss ***!
        \***************************************************************************************************************/
      /*! no static exports found */
      /***/
      (function(module, exports, __webpack_require__) {

        // Imports
        var ___CSS_LOADER_API_IMPORT___ = __webpack_require__( /*! ../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
        exports = ___CSS_LOADER_API_IMPORT___(false);
        // Module
        exports.push([module.i, "[data-isi-clone] {\n  position: fixed;\n  bottom: 0;\n  overflow: hidden;\n  overscroll-behavior: none;\n background: #FFF;\n  width: 100%;\n  will-change: transform;\n  z-index: 3; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    [data-isi-clone] {\n      transition: none !important; } }\n\n[data-isi-clone=\"expanded\"] {\n  overflow: scroll; }\n\n[data-isi-toggle] * {\n  pointer-events: none; }\n", ""]);
        // Exports
        module.exports = exports;


        /***/
      }),

    /***/
    "./node_modules/css-loader/dist/runtime/api.js":
      /*!*****************************************************!*\
        !*** ./node_modules/css-loader/dist/runtime/api.js ***!
        \*****************************************************/
      /*! no static exports found */
      /***/
      (function(module, exports, __webpack_require__) {

        "use strict";


        /*
          MIT License http://www.opensource.org/licenses/mit-license.php
          Author Tobias Koppers @sokra
        */
        // css base code, injected by the css-loader
        // eslint-disable-next-line func-names
        module.exports = function(useSourceMap) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function(item) {
              var content = cssWithMappingToString(item, useSourceMap);

              if(item[2]) {
                return "@media ".concat(item[2], " {").concat(content, "}");
              }

              return content;
            }).join('');
          }; // import a list of modules into the list
          // eslint-disable-next-line func-names


          list.i = function(modules, mediaQuery, dedupe) {
            if(typeof modules === 'string') {
              // eslint-disable-next-line no-param-reassign
              modules = [
                [null, modules, '']
              ];
            }

            var alreadyImportedModules = {};

            if(dedupe) {
              for(var i = 0; i < this.length; i++) {
                // eslint-disable-next-line prefer-destructuring
                var id = this[i][0];

                if(id != null) {
                  alreadyImportedModules[id] = true;
                }
              }
            }

            for(var _i = 0; _i < modules.length; _i++) {
              var item = [].concat(modules[_i]);

              if(dedupe && alreadyImportedModules[item[0]]) {
                // eslint-disable-next-line no-continue
                continue;
              }

              if(mediaQuery) {
                if(!item[2]) {
                  item[2] = mediaQuery;
                } else {
                  item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
                }
              }

              list.push(item);
            }
          };

          return list;
        };

        function cssWithMappingToString(item, useSourceMap) {
          var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

          var cssMapping = item[3];

          if(!cssMapping) {
            return content;
          }

          if(useSourceMap && typeof btoa === 'function') {
            var sourceMapping = toComment(cssMapping);
            var sourceURLs = cssMapping.sources.map(function(source) {
              return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
            });
            return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
          }

          return [content].join('\n');
        } // Adapted from convert-source-map (MIT)


        function toComment(sourceMap) {
          // eslint-disable-next-line no-undef
          var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
          var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
          return "/*# ".concat(data, " */");
        }

        /***/
      }),

    /***/
    "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
      /*!****************************************************************************!*\
        !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
        \****************************************************************************/
      /*! no static exports found */
      /***/
      (function(module, exports, __webpack_require__) {

        "use strict";


        var isOldIE = function isOldIE() {
          var memo;
          return function memorize() {
            if(typeof memo === 'undefined') {
              // Test for IE <= 9 as proposed by Browserhacks
              // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
              // Tests for existence of standard globals is to allow style-loader
              // to operate correctly into non-standard environments
              // @see https://github.com/webpack-contrib/style-loader/issues/177
              memo = Boolean(window && document && document.all && !window.atob);
            }

            return memo;
          };
        }();

        var getTarget = function getTarget() {
          var memo = {};
          return function memorize(target) {
            if(typeof memo[target] === 'undefined') {
              var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

              if(window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  // istanbul ignore next
                  styleTarget = null;
                }
              }

              memo[target] = styleTarget;
            }

            return memo[target];
          };
        }();

        var stylesInDom = [];

        function getIndexByIdentifier(identifier) {
          var result = -1;

          for(var i = 0; i < stylesInDom.length; i++) {
            if(stylesInDom[i].identifier === identifier) {
              result = i;
              break;
            }
          }

          return result;
        }

        function modulesToDom(list, options) {
          var idCountMap = {};
          var identifiers = [];

          for(var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var count = idCountMap[id] || 0;
            var identifier = "".concat(id, " ").concat(count);
            idCountMap[id] = count + 1;
            var index = getIndexByIdentifier(identifier);
            var obj = {
              css: item[1],
              media: item[2],
              sourceMap: item[3]
            };

            if(index !== -1) {
              stylesInDom[index].references++;
              stylesInDom[index].updater(obj);
            } else {
              stylesInDom.push({
                identifier: identifier,
                updater: addStyle(obj, options),
                references: 1
              });
            }

            identifiers.push(identifier);
          }

          return identifiers;
        }

        function insertStyleElement(options) {
          var style = document.createElement('style');
          var attributes = options.attributes || {};

          if(typeof attributes.nonce === 'undefined') {
            var nonce = true ? __webpack_require__.nc : undefined;

            if(nonce) {
              attributes.nonce = nonce;
            }
          }

          Object.keys(attributes).forEach(function(key) {
            style.setAttribute(key, attributes[key]);
          });

          if(typeof options.insert === 'function') {
            options.insert(style);
          } else {
            var target = getTarget(options.insert || 'head');

            if(!target) {
              throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            }

            target.appendChild(style);
          }

          return style;
        }

        function removeStyleElement(style) {
          // istanbul ignore if
          if(style.parentNode === null) {
            return false;
          }

          style.parentNode.removeChild(style);
        }
        /* istanbul ignore next  */


        var replaceText = function replaceText() {
          var textStore = [];
          return function replace(index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join('\n');
          };
        }();

        function applyToSingletonTag(style, index, remove, obj) {
          var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

          /* istanbul ignore if  */

          if(style.styleSheet) {
            style.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = style.childNodes;

            if(childNodes[index]) {
              style.removeChild(childNodes[index]);
            }

            if(childNodes.length) {
              style.insertBefore(cssNode, childNodes[index]);
            } else {
              style.appendChild(cssNode);
            }
          }
        }

        function applyToTag(style, options, obj) {
          var css = obj.css;
          var media = obj.media;
          var sourceMap = obj.sourceMap;

          if(media) {
            style.setAttribute('media', media);
          } else {
            style.removeAttribute('media');
          }

          if(sourceMap && btoa) {
            css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
          } // For old IE

          /* istanbul ignore if  */


          if(style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            while(style.firstChild) {
              style.removeChild(style.firstChild);
            }

            style.appendChild(document.createTextNode(css));
          }
        }

        var singleton = null;
        var singletonCounter = 0;

        function addStyle(obj, options) {
          var style;
          var update;
          var remove;

          if(options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = insertStyleElement(options));
            update = applyToSingletonTag.bind(null, style, styleIndex, false);
            remove = applyToSingletonTag.bind(null, style, styleIndex, true);
          } else {
            style = insertStyleElement(options);
            update = applyToTag.bind(null, style, options);

            remove = function remove() {
              removeStyleElement(style);
            };
          }

          update(obj);
          return function updateStyle(newObj) {
            if(newObj) {
              if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
                return;
              }

              update(obj = newObj);
            } else {
              remove();
            }
          };
        }

        module.exports = function(list, options) {
          options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page

          if(!options.singleton && typeof options.singleton !== 'boolean') {
            options.singleton = isOldIE();
          }

          list = list || [];
          var lastIdentifiers = modulesToDom(list, options);
          return function update(newList) {
            newList = newList || [];

            if(Object.prototype.toString.call(newList) !== '[object Array]') {
              return;
            }

            for(var i = 0; i < lastIdentifiers.length; i++) {
              var identifier = lastIdentifiers[i];
              var index = getIndexByIdentifier(identifier);
              stylesInDom[index].references--;
            }

            var newLastIdentifiers = modulesToDom(newList, options);

            for(var _i = 0; _i < lastIdentifiers.length; _i++) {
              var _identifier = lastIdentifiers[_i];

              var _index = getIndexByIdentifier(_identifier);

              if(stylesInDom[_index].references === 0) {
                stylesInDom[_index].updater();

                stylesInDom.splice(_index, 1);
              }
            }

            lastIdentifiers = newLastIdentifiers;
          };
        };

        /***/
      }),

    /***/
    "./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/
      /*! exports provided: default */
      /***/
      (function(module, __webpack_exports__, __webpack_require__) {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */
        __webpack_require__.d(__webpack_exports__, "default", function() {
          return FloatingISI;
        });
        /* harmony import */
        var _style_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./style.scss */ "./src/style.scss");
        /* harmony import */
        var _style_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_0__);

        function _classCallCheck(instance, Constructor) {
          if(!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _defineProperties(target, props) {
          for(var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if(protoProps) _defineProperties(Constructor.prototype, protoProps);
          if(staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        function _defineProperty(obj, key, value) {
          if(key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }

        function _classPrivateFieldGet(receiver, privateMap) {
          var descriptor = privateMap.get(receiver);
          if(!descriptor) {
            throw new TypeError("attempted to get private field on non-instance");
          }
          if(descriptor.get) {
            return descriptor.get.call(receiver);
          }
          return descriptor.value;
        }

        function _classPrivateFieldSet(receiver, privateMap, value) {
          var descriptor = privateMap.get(receiver);
          if(!descriptor) {
            throw new TypeError("attempted to set private field on non-instance");
          }
          if(descriptor.set) {
            descriptor.set.call(receiver, value);
          } else {
            if(!descriptor.writable) {
              throw new TypeError("attempted to set read only private field");
            }
            descriptor.value = value;
          }
          return value;
        }



        var FloatingISI = /*#__PURE__*/ function() {
          function FloatingISI() {
            var _this = this;

            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _classCallCheck(this, FloatingISI);

            _opts.set(this, {
              writable: true,
              value: void 0
            });

            _timer.set(this, {
              writable: true,
              value: false
            });

            _prevState.set(this, {
              writable: true,
              value: {}
            });

            _lock.set(this, {
              writable: true,
              value: 0
            });

            _defineProperty(this, "handleClick", function (e) {
              // Seconf nav ISI button
              if(document.querySelector("[data-isi-clone]")) {
                if(e.target.getAttribute("data-isi-toggle") === "isi"){
                  if (e.target.parentElement.getAttribute("aria-label") == "secondary-nav" || e.target.parentNode.parentNode.id == "isi-and-pi-mob" || e.target.getAttribute("title") == "Important Safety Information")  {
                    _this.status = "expanded";
                    document.querySelector("[data-isi-clone]").classList.add('show');
                    if(document.querySelector('body').classList.contains("mobile-menu")) {
                      let nav = document.querySelector('#primary-nav .nav');
                      let body = document.querySelector('body');
                      let menuIcon = document.querySelector("#navbar-toggler")

                      nav.classList.remove('active');
                      body.classList.remove('mobile-menu');
                      menuIcon.classList.remove('active');
                    }
                  }
                }
              }
              
              // Floating ISI expand & collapse button
              if(e.target.closest("[data-isi-toggle]")) {
                if((_this.state.status === "default" || _this.state.status === "collapsed") && (e.target.className.includes("expand-button"))) {
                  _this.status = "expanded";
                  document.querySelector("[data-isi-clone]").classList.add('show');
                } else if(e.target.className.includes("close-button")) {
                  _this.status = "collapsed";
                  setTimeout(() => {
                    document.querySelector("[data-isi-clone]").classList.remove('show');
                  }, 500);
                }
                if(this.state)
                  if(this.state.status === "collapsed" && e.target.className.includes("expand-button")) {
                    this.status = "expanded"
                  } else if(this.state.status === "expanded" && e.target.className.includes("close-button")) {
                    this.status = "collapsed"
                  }
              }
             
            });

            _defineProperty(this, "handleLock", function(e) {
              window.scrollTo(0, _classPrivateFieldGet(_this, _lock));
            });

            _defineProperty(this, "handleCollapse", function(e) {
              if(!_classPrivateFieldGet(_this, _opts).collapse) {
                return false;
              }

              if(window.scrollY > _classPrivateFieldGet(_this, _opts).collapsedOn) {
                _this.status = "collapsed";
              } else {
                _this.status = "default";
              }
            });

            if(!opts.target) {
              throw new Error('%cComponentsHC %cInvalid target node', "font-weight: bold");
            } // Parse Options


            _classPrivateFieldSet(this, _opts, Object.assign({
              defaultHeight: opts.defaultHeight || window.innerHeight / 3,
              collapsedHeight: 100,
              collapsedOn: 0,
              collapse: false,
              offsetTop: 0,
              animation: {
                duration: 500,
                easing: "linear"
              },
              target: opts.target || document.getElementById("isi")
            }, opts));

            this.state = {
              status: "default",
              visibility: true
            };
            this.clone = true;

            _classPrivateFieldSet(this, _timer, setInterval(function() {
              if(!_this.isInView(_classPrivateFieldGet(_this, _opts).target, _this.height)) {
                _this.clone = false;
                return;
              }

              return _this.clone = true; // console.log(this.clone)
            }, 0));

            document.addEventListener("click", this.handleClick);
            window.addEventListener("scroll", this.handleCollapse);
          }

          _createClass(FloatingISI, [{
            key: "isInView",
            value: function isInView(elem) {
              var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var bounding = elem.getBoundingClientRect();
              return bounding.top - window.innerHeight + offset >= 0;
            }
          }, {
            key: "setState",
            value: function setState(state) {
              _classPrivateFieldSet(this, _prevState, this.state);

              var newstate = Object.assign(_classPrivateFieldGet(this, _prevState), state); // this.state = Object.assign(this.state, state);

              this.state = newstate;
            }
          }, {
            key: "on",
            value: function on(evt, callback) {
              _classPrivateFieldGet(this, _opts).target.addEventListener(evt, callback, true);
            }
          }, {
            key: "height",
            get: function get() {
              if(this.state.status === "expanded") {
                return window.innerHeight - _classPrivateFieldGet(this, _opts).offsetTop;
              }

              if(this.state.status === "collapsed") {
                return _classPrivateFieldGet(this, _opts).collapsedHeight;
              }

              return _classPrivateFieldGet(this, _opts).defaultHeight || 0;
            }
          }, {
            key: "clone",
              set: function set(visible) {
              if(!visible) {
                document.querySelector('.bottom-nav-mobile').classList.add('hide');
                return this.clone.parentNode.removeChild(this.clone);
              } else {
                document.querySelector('.bottom-nav-mobile').classList.add('hide');
                return this.clone;
              }
            },
            get: function get() {
              var isi;

              if(document.querySelector("[data-isi-clone]")) {
                isi = document.querySelector("[data-isi-clone]");
              } else {
                isi = _classPrivateFieldGet(this, _opts).target.cloneNode(true);
                document.body.appendChild(isi);
              }

              isi.setAttribute('data-isi-clone', this.state.status);
              if(document.querySelector('[data-isi-clone]').classList.contains("not-clone")) {
                document.querySelector('[data-isi-clone]').setAttribute("role", "complementary")
                document.querySelector('[data-isi-clone]').setAttribute("aria-label", "Important Safety Information")
                document.querySelector('[data-isi-clone]').classList.remove("not-clone")
              }
              Object.assign(isi.style, {
                height: "".concat(this.height, "px"),
                transitionDuration: "".concat(_classPrivateFieldGet(this, _opts).animation.duration, "ms"),
                transitionTimingFunction: _classPrivateFieldGet(this, _opts).animation.easing
              });
              return isi;
            }
          }, {
            key: "status",
            set: function set(status) {
              if(!_classPrivateFieldGet(this, _opts).target.dispatchEvent(new CustomEvent(status, {
                  cancelable: true,
                  detail: this
                }))) {
                return false;
              }

              if ("expanded" == status) {

                _classPrivateFieldSet(this, _lock, window.scrollY);

                window.addEventListener("scroll", this.handleLock, false);
                document.body.classList.add('show-isi');
              } else {
                window.removeEventListener("scroll", this.handleLock, false);
                document.body.classList.remove('show-isi');
              }

              this.setState({
                status: status
              });

              _classPrivateFieldGet(this, _opts).target.dispatchEvent(new CustomEvent("change", {
                detail: this
              }));
            },
            get: function get() {
              return this.state.status;
            }
          }]);

          return FloatingISI;
        }(); // new FloatingISI({
        //   target: document.getElementById("isi"),
        //   defaultHeight: 190
        // })


        var _opts = new WeakMap();

        var _timer = new WeakMap();

        var _prevState = new WeakMap();

        var _lock = new WeakMap();



        /***/
      }),

    /***/
    "./src/style.scss":
      /*!************************!*\
        !*** ./src/style.scss ***!
        \************************/
      /*! no static exports found */
      /***/
      (function(module, exports, __webpack_require__) {

        var api = __webpack_require__( /*! ../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
        var content = __webpack_require__( /*! !../node_modules/css-loader/dist/cjs.js!../node_modules/sass-loader/dist/cjs.js??ref--5-2!./style.scss */ "./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js?!./src/style.scss");

        content = content.__esModule ? content.default : content;

        if(typeof content === 'string') {
          content = [
            [module.i, content, '']
          ];
        }

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update = api(content, options);

        var exported = content.locals ? content.locals : {};



        module.exports = exported;

        /***/
      })

    /******/
  });
});
//# sourceMappingURL=componentshc-floating-isi.js.map